document.onreadystatechange = function () {
  if (document.readyState === 'complete') {
    /* SAMPLE VARIANT FUNCTIONS START  */
    var sample_v_container = $('.sample-variant-container');
    if (sample_v_container.length > 0) {
      $('button[data-sample-atc]').on('click', function(){
        let qty = $('.sample-variant-container input[name="qty"]').val();
        let vid = Number($('.sample-variant-container input[name="qty"]').attr('data-vid'));
        if (qty > 0) {
          $('button[data-sample-atc]').children('.atc-text').css('visibility', 'hidden');
          $('button[data-sample-atc]').children('.atc-spinner').css('display', 'flex');
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: qty,
              id: vid
            },
            dataType: 'json', 
            success: function (data) {
              $('button[data-sample-atc]').children('.atc-text').css('visibility', 'visible');
              $('button[data-sample-atc]').children('.atc-spinner').css('display', 'none');
              Shopify.onItemAdded();
      
            },
            error: function (error) {
              console.log($(error));
              $('button[data-sample-atc]').children('.atc-text').css('visibility', 'visible');
              $('button[data-sample-atc]').children('.atc-spinner').css('display', 'none');
            }
          });
        }
      });
    }
    /* SAMPLE VARIANT FUNCTIONS FINISH */
    /* TABLE VARIANT SELECTOR FUNCTIONS START  */
    var table_variant_selector = $('#variant-selector-table');
    if (table_variant_selector.length > 0) {
      $('button[data-table-atc]').on('click', function(){
        let inputs_qty = $('#variant-selector-table tbody tr[data-stock="true"] input[name="qty"]');
        if (inputs_qty.length > 0) {
          let items = [];
          for (let i = 0; i < inputs_qty.length; i++)
          {
            let val = inputs_qty[i].value;
            let vid = inputs_qty[i].getAttribute('data-vid');
            if (val > 0) {
              let obj = {'quantity': val, 'id': vid};
              items.push(obj);
            }
          }
          $('button[data-table-atc]').children('.atc-text').css('visibility', 'hidden');
          $('button[data-table-atc]').children('.atc-spinner').css('display', 'flex');
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {items},
            dataType: 'json', 
            success: function (data) {
              $('button[data-table-atc]').children('.atc-text').css('visibility', 'visible');
              $('button[data-table-atc]').children('.atc-spinner').css('display', 'none');
              Shopify.onItemAdded();
      
            },
            error: function (error) {
              console.log($(error));
              $('button[data-table-atc]').children('.atc-text').css('visibility', 'visible');
              $('button[data-table-atc]').children('.atc-spinner').css('display', 'none');
            }
          });
        }
        
      });
      
    }
    /* TABLE VARIANT SELECTOR FUNCTIONS FINISH */
  }
}